$(document).ready(function() {
  $(window).on('scroll', function() {
    if (0 < $(this).scrollTop()) {
      $('body').addClass('fix');
      $('.melon-header-transparent').removeClass('transparent');
    } else {
      $('body').removeClass('fix');
      $('.melon-header-transparent').addClass('transparent');
    }
  });

  $(window).scroll(function() {
    var topCurrent = $(document).scrollTop();
    var subMenuPos = $('.kpop-content').offset().top;
    var headerHeight = $('#header').height();
    var eventTarget = $('.sub-menu');
    if (topCurrent > subMenuPos - headerHeight) {
      eventTarget.addClass('fix');
    } else {
      eventTarget.removeClass('fix');
    }
  });

  $(window).scroll(function() {
    var topCurrent = $(document).scrollTop();
    var posBgY = topCurrent / 2;
    $('.kpop-cont .bg-interaction').css('background-position-y', posBgY + 'px');
  });

  $('.board-rank .list-rank').slick({
    autoplay: true,
    arrows: false,
    vertical: true,
    draggable: false,
    swipe: false,
    pauseOnHover: false
  });

  $('.chart-opened .list-chart').slick({
    slidesToScroll: 1,
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    variableWidth: true,
    arrows: false,
    draggable: false,
    swipe: false,
    pauseOnHover: false,
    cssEase: 'linear'
  });

  $('.kpop-detail .list-detail').on('init', function(event, slick) {
    $('.kpop-detail .list-detail').find('.slick-current').removeClass('slick-current').addClass('reset-animation');
    setTimeout(function() {
      $('.kpop-detail .list-detail').find('.reset-animation').removeClass('reset-animation').addClass('slick-current');
    }, 1);
  });

  $('.kpop-detail .list-detail').slick({
    initialSlide: 0,
    infinite: false,
    lazyLoad: 'ondemand',
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    variableWidth: true,
    focusOnChange: false,
    accessibility: false,
    adaptiveHeight: true
  });

  $('.kpop-detail .list-detail').on('afterChange', function(event, slick, currentSlide) {
    $('.slick-list').height($('.kpop-detail .slick-current .detail-content').innerHeight());
    $(slick.$slides).removeClass('slick-prev');
  });

  $('.kpop-detail .list-detail').on('beforeChange', function(event, slick, currentSlide) {
    $(slick.$slides[currentSlide]).addClass('slick-prev');
  });

  $.fn.contentActive = function(translatePos) {
    var topCurrent = $(document).scrollTop();
    var target = this;
    var targetPos = this.offset().top;
    var targetTranslatePos = 0;
    var winHeight = $(window).height();

    targetTranslatePos = translatePos === undefined ? 0 : translatePos;

    $(window).resize(function() {
      winHeight = $(window).height();
    });
    if (topCurrent > targetPos - winHeight - targetTranslatePos) {
      target.addClass('active');
    }
    $(window).scroll(function() {
      if ($(document).scrollTop() > targetPos - winHeight - targetTranslatePos) {
        target.addClass('active');
      } else {
        target.removeClass('active');
      }
    });
  };

  $('.tab-menu').each(function() {
    $(this).contentActive();
  });
  $('.chart-year').each(function() {
    $(this).contentActive(100);
  });
  $('.chart-year .list-music li').each(function() {
    $(this).contentActive(100);
  });
  $('.chart-open').each(function() {
    $(this).contentActive();
  });
  $('.event-banner').each(function() {
    $(this).contentActive();
  });
  $('.masterpiece-banner').each(function() {
    $(this).contentActive(100);
  });
  $('.board-rank').each(function() {
    $(this).contentActive();
  });
  $('.chart-rank .list-music li').each(function() {
    $(this).contentActive(100);
  });
  $('.chart-special').each(function() {
    $(this).contentActive();
  });
  $('.chart-special .list-special li').each(function() {
    $(this).contentActive(100);
  });
  $('.chart-special-large .item-rankup').each(function() {
    $(this).contentActive(100);
  });

  $('.info-review .txt-review').on('click', function() {
    $(this).closest('.music-content').find('.btn-more-review').toggleClass('open');
    $(this).closest('.info-review').toggleClass('open');
    $('.slick-list').height($(this).closest('.detail-content').innerHeight());
  });
  $('.btn-more-review').on('click', function() {
    $(this).toggleClass('open');
    $(this).siblings('.info-music').children('.info-review').toggleClass('open');
    $('.slick-list').height($(this).closest('.detail-content').innerHeight());
  });

  //video MELONUIT-1975 영상이슈 230522
  setTimeout(function() {
    $('.head-bg video').show();
  }, 1500);
});

// 접근성: 공유하기 모달 포커스 관리
(function() {
  var $shareTrigger = null;
  var keydownHandler = null;
  var FOCUSABLE = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';

  function onModalOpen($modal) {
    // ARIA 속성 추가
    $modal.attr({
      'role': 'dialog',
      'aria-modal': 'true',
      'aria-labelledby': 'snsShareTitle',
      'tabindex': '-1'
    });
    $modal.find('h2.title').attr('id', 'snsShareTitle');

    // 배경 콘텐츠 접근성 트리에서 차단 (VoiceOver 스와이프 탐색 차단)
    $('.container-doc').attr('aria-hidden', 'true').attr('inert', '');

    // 300ms 딜레이 후 첫 번째 포커스 가능한 요소로 포커스 이동
    setTimeout(function() {
      var $focusables = $modal.find(FOCUSABLE).filter(':visible');
      if ($focusables.length) {
        $focusables.first().focus();
      } else {
        $modal.focus();
      }
    }, 300);

    // 포커스 트랩 + ESC 키 처리
    keydownHandler = function(e) {
      if (e.key === 'Escape') {
        $modal.find('.close_side').trigger('click');
        return;
      }
      if (e.key !== 'Tab') return;

      var $focusables = $modal.find(FOCUSABLE).filter(':visible');
      if (!$focusables.length) return;

      var first = $focusables.first()[0];
      var last = $focusables.last()[0];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', keydownHandler);
  }

  function onModalClose() {
    // 배경 콘텐츠 복원
    $('.container-doc').removeAttr('aria-hidden').removeAttr('inert');

    // 키보드 이벤트 제거
    if (keydownHandler) {
      document.removeEventListener('keydown', keydownHandler);
      keydownHandler = null;
    }

    // 공유하기 버튼으로 포커스 복귀
    if ($shareTrigger && $shareTrigger.length) {
      $shareTrigger.focus();
      $shareTrigger = null;
    }
  }

  // 공유하기 버튼 클릭 시 모달 열기 처리
  $(document).on('click', '.btn-share', function() {
    $shareTrigger = $(this);
    var $modal = $('#snsShare');
    if ($modal.length) onModalOpen($modal);
  });

  // 모달 닫기 처리 (닫기 버튼, 백드롭 클릭)
  $(document).on('click', '#snsShare .close_side, #snsShare .modal_backdrop', function() {
    onModalClose();
  });
}());
